import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b7050de8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=b7050de8&prod&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=b7050de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7050de8",
  null
  
)

export default component.exports